import { render, staticRenderFns } from "./OrderSendMessage.vue?vue&type=template&id=4430251e&scoped=true"
import script from "./OrderSendMessage.vue?vue&type=script&lang=js"
export * from "./OrderSendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4430251e",
  null
  
)

export default component.exports